import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'
import useTranslation from '../../../../hooks/useTranslation'

export const PriceInfoGuideTooltip = (props: any) => {
  const { setIsOpenPurchaseInfoGuideModal } = props
  const { t } = useTranslation()

  return (
    <div
      className={classNames(
        'flex flex-col p-[16px] md:p-[32px] gap-[10px] bg-white   h-auto  border-[3px] border-main  rounded-[20px] text-black font-medium w-[330px]',
        {
          ' absolute left-0 top-0  z-50 ': !isMobile,
          ' absolute left-2  z-50 ': isMobile,
        }
      )}
    >
      <p className=" md:leading-[19.2px] md:text-base  leading-[12px] text-[10px] flex items-center justify-between">
        <span className="font-bold text-[20px]">{t('productVideoEditor.priceInfoGuideTooltip.title')}</span>
        <img
          src="assets/img/Icon_x.png"
          alt="icon_x"
          height={24}
          width={24}
          onClick={() => {
            setIsOpenPurchaseInfoGuideModal(false)
          }}
          className=" cursor-pointer"
        />
      </p>
      <p className="font-[400]">
        {t('productVideoEditor.priceInfoGuideTooltip.description')}
      </p>

      <div className="flex gap-2">
        <div className="flex flex-col">
          <p className="font-bold text-main">{t('productVideoEditor.priceInfoGuideTooltip.include')}</p>{' '}
          <img src="assets/img/add_price_info.png" alt="" />
        </div>
        <div className="flex flex-col">
          <p className="font-bold text-main">{t('productVideoEditor.priceInfoGuideTooltip.exclude')}</p>
          <img src="assets/img/empty_price_info.png" alt="" />
        </div>
      </div>
    </div>
  )
}
